type Params = {
  vat: string,
  vatPrice: string,
  price: string
  displayVAT?: boolean,
}

export const createVATComboPrice = ({ vat, vatPrice, price, displayVAT }: Params) => displayVAT ? vat === '0' ? vatPrice : `${vatPrice} + ${vat} VAT` : price;